export class Environment {
	production: boolean;
	prefixes: string;
	envName: string;
	apiPath?: string;
}
